import { WidgetConfigEntity }               from '..';
import { ConfigService }                    from '../../..';

/**
 * The widget config factory is responsible of business logic related to 
 * widget configuration parameters retrieved from IFaq server and their
 * instantiation rules.
 */
export class WidgetConfigFactory { 

    /**
     * Parse IFaqServer answer and returns the associated widget configuration entity encapsulating some 
     * initialization business rules to provide a list of parameters ready to use.
     * 
     * @param chatbotConfig - The IFaq server response containing whole widget configuration parameters
     */
    public static buildWidgetConfigurationEntity(chatbotConfig: any): WidgetConfigEntity | null {
        const paramNames: string[] = Object.getOwnPropertyNames(chatbotConfig);
        const paramsMap: Map<string, any> = new Map<string, any>();
        const botKey: string | undefined = ConfigService.botKey;

        if (!botKey) {
            return null;
        }

        paramNames.forEach((paramName: string) => {
            if (chatbotConfig[paramName]) {
                let paramValue: string = chatbotConfig[paramName].value;
               
                if (paramValue) {
                    paramValue.trim();

                    // manage booleans
                    switch (paramValue) {

                        case "false":
                            paramsMap.set(paramName, false);
                            break;

                        case "true":
                            paramsMap.set(paramName, true);
                            break;

                        default:
                            if (paramName === 'truncateMaxMessageSize') {
                                const truncatePolicy: string = chatbotConfig['truncatePolicy'].value;
                                let maxHeightMessage: number = Number.parseInt(paramValue, 10);
                                if (truncatePolicy === '') {
                                    maxHeightMessage = -1;
                                }
                                
                                (isNaN(maxHeightMessage) || maxHeightMessage <= 0 || maxHeightMessage < ConfigService.getMinMessageHeight()) ? paramsMap.set(paramName, -1) 
                                                                                                                                             : paramsMap.set(paramName, maxHeightMessage);
                            } else if (paramName === 'truncateBotOptions') {
                                const maxBotOptions: number = Number.parseInt(paramValue, 10);
                                (isNaN(maxBotOptions) || maxBotOptions <= 0) ? paramsMap.set(paramName, 5) // max 5 buttons is the default value
                                                                             : paramsMap.set(paramName, maxBotOptions);
                            } else if (paramName === 'emoAvatarPlayTime') {
                                const emoAvatarPlayTime: number = Number.parseInt(paramValue, 10);
                                (isNaN(emoAvatarPlayTime) || emoAvatarPlayTime <= 0) ? paramsMap.set(paramName, -1) 
                                                                                     : paramsMap.set(paramName, emoAvatarPlayTime);
                            } else if (paramName === 'emoAvatarFormat') {
                                paramValue = paramValue.replace(/\s/g, '');
                                paramValue = paramValue.toLowerCase();
                                paramsMap.set(paramName, paramValue);

                            } else if (paramName === 'cssCustom') {
                                paramValue = paramValue.replace(/\s/g, '');
                                paramsMap.set(paramName, paramValue);
                                
                            } else if (paramName === 'panelTextFontSize') {
                                const panelTextFontSize: number = Number.parseFloat(paramValue);
                                (isNaN(panelTextFontSize) || panelTextFontSize <= 0) ? paramsMap.set(paramName, -1) 
                                                                                     : paramsMap.set(paramName, panelTextFontSize);
                            } else {
                                paramsMap.set(paramName, paramValue);
                            }
                    }
                }
            }
        });

        // set the execution language
        paramsMap.set('language', ConfigService.getLanguageToUse(chatbotConfig['language'].value));

        // set internationalized parameter values giving the configured language
        paramNames.forEach((paramName: string) => {
            if (chatbotConfig[paramName]) {
                const i18nValue: string = 'value_'+ paramsMap.get('language');
                const paramValue: string = chatbotConfig[paramName][i18nValue];
                if(paramValue) {
                    paramsMap.set(paramName, paramValue);
                }
            }
        });

        // override parameters configured from integration script
        if (window.botSettings) {
            const integrationScriptParams: string[] = Object.getOwnPropertyNames(window.botSettings);
            integrationScriptParams.forEach((paramName: string) => {
                if (paramName !== 'faqId' && paramName !== 'synapseBotId' && paramName !== 'botKey') {
                    paramsMap.set(paramName, window.botSettings[paramName]);
                }
            });
        }
        return new WidgetConfigEntity(botKey, paramsMap);
    }
}
